<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addController" v-if="permissionCodes.indexOf('004006001') !== -1" />
        <!--<button-upload-->
          <!--:cathUrl="uploadUrl"-->
          <!--:onSuccess="onUploadSuccess"-->
          <!--@getpage="getPage"-->
          <!--v-if="permissionCodes.indexOf('004004010') !== -1"-->
          <!--value="导入"/>-->
        <!--<button-export-->
          <!--:href="exportUrl"-->
          <!--:beforeDownload="beforeDownload"-->
          <!--download="download.xls"-->
          <!--value="导出"/>-->
      </div>
      <input-search placeholder="车主姓名/车牌号" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage" @changePagination="changePagination" :operationArr="operationArr" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "black-list-vehicles-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "黑名单"
        }
      ],
      addController: "black-list-vehicles-add",
      exportUrl: "",
      uploadUrl: "",
      tableHead: [
        {
          prop: "carNumber",
          label: "车牌号"
        },
        {
          prop: "carOwnerName",
          label: "车主姓名"
        },
        {
          prop: "carOwnerPhone",
          label: "车主手机号"
        },
        {
          prop: "enterpriseName",
          label: "车辆所属住户"
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        isWhite: "0",
        searchKey: ""
      },
      operationArr: ["modify", "delete"]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.uploadUrl = api.importAuthority;
    // this.exportUrl = `${api.exportAuthority}?yq-app-code=${bus.global.yqCode}&kj-type=gy`
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportAuthority}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}`;
    },
    // 获取分页
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getCarWhiteBlackPage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {});
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取数据失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/black_list_vehicles_modify/${code}`
      });
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteCarWhiteBlack, code)
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/BlackListVehicles/BlackListVehiclesManage.vue